//树数据处理
function toTree(data) {
    let treeData = [];
    if (!Array.isArray(data)) return treeData;

    data.forEach((item) => {
        delete item.children; //删除item下的children，以防多次调用
    });

    let map = {};
    data.forEach((item) => {
        map[item.adminmenuid] = item;
    });

    data.forEach((item) => {
        let parent = map[item.parent]; //判断item的pid是否是否存在map中
        if (parent) {
            //如果存在则表示item不是最顶层的数据
            (parent.children || (parent.children = [])).push(item);
        } else {
            treeData.push(item); // 如果不存在 则是顶层数据
        }
    });
    return treeData;
}
//随机密码
function getRandomPassword(number) {
    var charsNumber = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var str = '';
    for (var i = 0; i < number; i++) {
        var id = Math.ceil(Math.random() * 35);
        str += charsNumber[id];
    }
    return str;
}
function randomPassword(length) {
    length = Number(length);
    // Limit length
    // if (length < 6) {
    //   length = 6
    // } else if (length > 16) {
    //   length = 16
    // }
    let passwordArray = ['ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz', '1234567890', '1234567890'];
    // let passwordArray = ['ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz', '1234567890', '!@#$%&*()'];
    var password = [];
    let n = 0;
    for (let i = 0; i < length; i++) {
        if (password.length < length - 4) {
            let arrayRandom = Math.floor(Math.random() * 4);
            let passwordItem = passwordArray[arrayRandom];

            let item = passwordItem[Math.floor(Math.random() * passwordItem.length)];
            password.push(item);
        } else {
            let newItem = passwordArray[n];
            let lastItem = newItem[Math.floor(Math.random() * newItem.length)];
            let spliceIndex = Math.floor(Math.random() * password.length);
            password.splice(spliceIndex, 0, lastItem);
            n++;
        }
    }
    return password.join('');
}

/**
 * 菜单树形结构数据转化
 * @param {*} data 菜单数据 返回tree结构
 */
function getMenuTreeData(data) {
    if (!Array.isArray(data) && !data.length) {
        return [];
    }
    let RootData = data.filter((value) => value.level == '1');
    let transformFun = (RootData, data) => {
        RootData.forEach((rootItem) => {
            data.forEach((childItem, index) => {
                if (childItem.parent === rootItem.menuid) {
                    let temp = JSON.parse(JSON.stringify(data));
                    temp.splice(index, 1);
                    transformFun([childItem], temp);
                    rootItem.children ? rootItem.children.push(childItem) : (rootItem.children = [childItem]);
                }
            });
        });
    };
    transformFun(RootData, data);
    console.log('RootData', RootData);
    return RootData;
}
function formatTime(unixTimestamp, type) {
    let dt = new Date(unixTimestamp * 1000);
    if (!Number(unixTimestamp) || Number(unixTimestamp) <= 0 || Number(unixTimestamp) == 1) {
        return '—';
    }
    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let mMonth = month >= 10 ? month : '0' + month;
    let day = dt.getDate() >= 10 ? dt.getDate() : '0' + dt.getDate();
    let hours = dt.getHours();
    let minutes = dt.getMinutes();
    let seconds = dt.getSeconds();
    if (hours < 10) hours = '0' + hours;

    if (minutes < 10) minutes = '0' + minutes;
    if (seconds < 10) seconds = '0' + seconds;
    switch (type) {
        case 1:
            return hours + ':' + minutes + ':' + seconds; //小时:分钟:秒  格式
        case 2:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
        case 3:
            return year + '-' + month + '-' + day; //年-月-日 格式
        case 4:
            return hours + ':' + minutes + ':' + seconds;
        case 5:
            return hours + ':' + minutes;
        case 6:
            return year + '-' + month + '-' + day + ' 00:00:00';
        case 7:
            return year + '-' + month + '-' + day + ' 23:59:59';
        case 8:
            return year + '-' + mMonth + '-' + day; //2012-01-11 格式
        default:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
    }
}
/**
 * 加法函数，用来得到精确的加法结果
 * @param {Object} arg1
 * @param {Object} arg2
 */
function accAdd(arg1, arg2) {
    var r1 = deal(arg1);
    var r2 = deal(arg2);
    var m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
}
/**
 * 精确减法函数
 */
function accSub(arg1, arg2) {
    var r1 = deal(arg1);
    var r2 = deal(arg2);
    var m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m - arg2 * m) / m
}

/**
 * 乘法函数，用来得到精确的乘法结果
 * @param {Object} arg1
 * @param {Object} arg2
 */
function accMul(arg1, arg2) {
    var m = 0;
    m += deal(arg1);
    m += deal(arg2);
    var r1 = Number(arg1.toString().replace(".", ""));
    var r2 = Number(arg2.toString().replace(".", ""));
    return (r1 * r2) / Math.pow(10, m)
}

/**
 * 除法函数，用来得到精确的除法结果
 * @param {Object} arg1
 * @param {Object} arg2
 */
function accDiv(arg1, arg2) {
    var t1 = deal(arg1);
    var t2 = deal(arg2);
    var r1 = Number(arg1.toString().replace(".", ""))
    var r2 = Number(arg2.toString().replace(".", ""))
    return accMul((r1 / r2), Math.pow(10, t2 - t1));
    // return (r1 / r2) * Math.pow(10, t2 - t1);
}
/**
 * 求小数点后的数据长度
 */
function deal(arg) {
    var t = 0;
    try {
        t = arg.toString().split(".")[1].length
    } catch (e) { }
    return t;
}

// 前缀方法
function prefix(url) {
    // 获取当前环境
    let currentDomain = window.location.origin
    const currentEnv = process.env.NODE_ENV || 'development';
   let devUrl = 'https://rdnsmgr-test.fftechs.com'
    if (url && url.startsWith('http')) {
      return url
    } else {
        if(currentEnv === 'development'){
            url = devUrl + url
            return url
        }else{
            url = currentDomain + url
            return url
        }
    }
}

export default {
    toTree,
    getMenuTreeData,
    getRandomPassword,
    formatTime,
    randomPassword,
    accAdd,
    accMul,
    accDiv,
    accSub,
    prefix
};



// WEBPACK FOOTER //
// ./src/utils/tools.js